package com.rainbowclubs.rainbow.presentation.theme

import androidx.compose.ui.graphics.Color

val md_theme_light_primary = Color(0xFF5F48F7)
val md_theme_light_onPrimary = Color(0xFFFFFFFF)
val md_theme_light_primaryContainer = Color(0xFF89F8C7)
val md_theme_light_onPrimaryContainer = Color(0xFF002114)
val md_theme_light_secondary = Color(0xFF4D6357)
val md_theme_light_onSecondary = Color(0xFFFFFFFF)
val md_theme_light_secondaryContainer = Color(0xFFCFE9D9)
val md_theme_light_onSecondaryContainer = Color(0xFF092016)
val md_theme_light_tertiary = Color(0xFF3D6373)
val md_theme_light_onTertiary = Color(0xFFFFFFFF)
val md_theme_light_tertiaryContainer = Color(0xFFC1E8FB)
val md_theme_light_onTertiaryContainer = Color(0xFF001F29)
val md_theme_light_error = Color(0xFFBA1A1A)
val md_theme_light_errorContainer = Color(0xFFFFDAD6)
val md_theme_light_onError = Color(0xFFFFFFFF)
val md_theme_light_onErrorContainer = Color(0xFF410002)
val md_theme_light_background = Color(0xFFFFFBF8) // Reviewed
val md_theme_light_onBackground = Color(0xFF191C1A)
val md_theme_light_surface = Color(0xFFFFFFFF) // Reviewed
val md_theme_light_onSurface = Color(0xFF191C1A)
val md_theme_light_surfaceVariant = Color(0xFFDBDBDB)
val md_theme_light_onSurfaceVariant = Color(0xFF303031)
val md_theme_light_outline = Color(0xFF888888) // Reviewed
val md_theme_light_inverseOnSurface = Color(0xFFEFF1EE)
val md_theme_light_inverseSurface = Color(0xFF2E312F)
val md_theme_light_inversePrimary = Color(0xFF6CDBAC)
val md_theme_light_shadow = Color(0xFF000000)
val md_theme_light_surfaceTint = Color(0xFF006C4C)
val md_theme_light_outlineVariant = Color(0xFFE5E2FF) // Reviewed
val md_theme_light_scrim = Color(0xFF000000)

val light_blue_background = Color(0xFFEAF5FF)

val light_yellow_background = Color(0xFFFFF7E6)

val md_theme_dark_primary = Color(0xFF6CDBAC)
val md_theme_dark_onPrimary = Color(0xFF003826)
val md_theme_dark_primaryContainer = Color(0xFF005138)
val md_theme_dark_onPrimaryContainer = Color(0xFF89F8C7)
val md_theme_dark_secondary = Color(0xFFB4CCBE)
val md_theme_dark_onSecondary = Color(0xFF1F352A)
val md_theme_dark_secondaryContainer = Color(0xFF354B40)
val md_theme_dark_onSecondaryContainer = Color(0xFFCFE9D9)
val md_theme_dark_tertiary = Color(0xFFA5CCE0)
val md_theme_dark_onTertiary = Color(0xFF073543)
val md_theme_dark_tertiaryContainer = Color(0xFF244C5B)
val md_theme_dark_onTertiaryContainer = Color(0xFFC1E8FB)
val md_theme_dark_error = Color(0xFFFFB4AB)
val md_theme_dark_errorContainer = Color(0xFF93000A)
val md_theme_dark_onError = Color(0xFF690005)
val md_theme_dark_onErrorContainer = Color(0xFFFFDAD6)
val md_theme_dark_background = Color(0xFF191C1A)
val md_theme_dark_onBackground = Color(0xFFE1E3E0)
val md_theme_dark_surface = Color(0xFF191C1A)
val md_theme_dark_onSurface = Color(0xFFE1E3E0)
val md_theme_dark_surfaceVariant = Color(0xFF404944)
val md_theme_dark_onSurfaceVariant = Color(0xFFBFC9C2)
val md_theme_dark_outline = Color(0xFF8A938D)
val md_theme_dark_inverseOnSurface = Color(0xFF191C1A)
val md_theme_dark_inverseSurface = Color(0xFFE1E3E0)
val md_theme_dark_inversePrimary = Color(0xFF006C4C)
val md_theme_dark_shadow = Color(0xFF000000)
val md_theme_dark_surfaceTint = Color(0xFF6CDBAC)
val md_theme_dark_outlineVariant = Color(0xFF404944)
val md_theme_dark_scrim = Color(0xFF000000)

val rsvp_going = Color(0xFF6CDBAC)
val rsvp_going_bg = Color(0xFFF1FAF5)
val rsvp_maybe = Color(0xFFFF9500)
val rsvp_maybe_bg = Color(0xFFFFF9F0)
val rsvp_not_going = Color(0xFFFF3B30)
val rsvp_not_going_bg = Color(0xFFFFF2F1)

val accent_purple = Color(0xFF7658F5)
val accent_green = Color(0xFF35CF76)
val accent_orange = Color(0xFFFF920A)
val accent_blue = Color(0xFF2489F5)

val rainbow_pink = Color(0xFFF48FB1)
val rainbow_orange = Color(0xFFFFCC80)
val rainbow_yellow = Color(0xFFFFF59D)
val rainbow_green = Color(0xFFA5D6A7)
val rainbow_blue = Color(0xFF90CAF9)
val rainbow_purple = Color(0xFFCE93D8)

val rainbow_colors = listOf(
    rainbow_pink,
    rainbow_orange,
    rainbow_yellow,
    rainbow_green,
    rainbow_blue,
    rainbow_purple,
)
